module.exports = __webpack_public_path__ + "static/media/HealingSession.e9f36944.jpg";